import { Component, Input, OnChanges, OnInit, SimpleChanges, TemplateRef, ViewEncapsulation } from '@angular/core';
import { Observable, of } from 'rxjs';
import { SessionManagerService } from '@nida-web/api/rest/authentication';
import { map } from 'rxjs/operators';

@Component({
  selector: 'nida-web-shared-feature-permission-check',
  templateUrl: './permission-check.component.html',
  styleUrls: ['./permission-check.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  standalone: false,
})
export class PermissionCheckComponent implements OnInit, OnChanges {
  /**
   * @param neededPermission checks has permission with rw ro, empty list [] means no permission needed
   * @param hasPermission is used directly as boolean observable
   */

  @Input() neededPermission?: string[] | undefined;
  @Input() templateRef: TemplateRef<any>;
  @Input() hasPermission?: boolean;

  public hasPermission$?: Observable<{ hasPermission: boolean }>;

  constructor(private sessionManager: SessionManagerService) {}

  ngOnInit() {
    if (this.neededPermission) {
      this.checkPermissions();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.neededPermission) {
      this.checkPermissions();
    }
  }

  checkPermissions() {
    if (this.neededPermission && this.hasPermission) {
      throw new Error('hasPermission || neededPermission need to be provided');
    }

    // neededPermission is undefined
    if (this.neededPermission === undefined) {
      this.hasPermission$ = of({ hasPermission: false });
      return;
    }

    // no permissions are necessary
    if (this.neededPermission.length === 0) {
      this.hasPermission$ = of({ hasPermission: true });
      return;
    }

    // permissions are given
    this.hasPermission$ = this.sessionManager
      .hasPermissionWithRwRo(this.neededPermission)
      .pipe(map((hasPermission) => ({ hasPermission })));
  }
}
